module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('em', [_c('strong', [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Matthew 1")])])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-6"
    }
  }, [_c('strong', [_vm._v("I. THE BIRTH AND INFANCY OF JESUS, 1:1-2:23")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("The opening to this Gospel"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "ft1"
    }
  }, [_vm._v("1")]), _vm._v(" is quite different from that of any of the others. Its prologue is the shortest of the four, except for that of Mark. Indeed, it is best regarded as no more than a heading. Immediately and without further discussion the narrative launches into the genealogy of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotet"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("1")]), _vm._v("The book of the story of Jesus Christ, the son of David, the son of Abraham.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_c('strong', [_vm._v("1")]), _vm._v(". Matthew has his own way of beginning a Gospel: none of the other Evangelists begins like this. His opening word is the normal word for “book,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn2",
      "id": "ft2"
    }
  }, [_vm._v("2")])]), _vm._v(" though BAGD notes that in later writings it was especially used of a “sacred, venerable book,” which thus makes it very suitable for the kind of book that Matthew was writing. That lexicon does not note its use for anything other than a book of some sort, which makes it unlikely that we should take Matthew to be referring to a short section such as the nativity stories. The word I have translated "), _c('em', [_vm._v("story"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn3",
      "id": "ft3"
    }
  }, [_vm._v("3")])])]), _vm._v(" is difficult. The term is "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("used of birth or origin or existence, but none of these meanings is easy to see in the present passage. There is evidence that the word was already used as the title of the first book of the Old Testament in LXX,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn4",
      "id": "ft4"
    }
  }, [_vm._v("4")]), _vm._v(" and it may well be that Matthew used it as the title of the book in which he would write about the new genesis, the new creation in Jesus Christ. The two opening words are combined elsewhere in Scripture only twice. In Genesis 2:4 the combination seems clearly to be used as the heading for the history that follows, and that seems the best way to take it also in Genesis 5:1. These examples may well give us the clue to its meaning here. The expression is best seen as the heading for the whole Gospel. It has usually been regarded as simply introducing the genealogy, but it would be curious to have a heading for the first half chapter and not one for the book as a whole."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn5",
      "id": "ft5"
    }
  }, [_vm._v("5")])]), _vm._v(" Zahn was surely right when he saw the meaning as “Book of the History of Jesus Christ.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn6",
      "id": "ft6"
    }
  }, [_vm._v("6")])]), _vm._v(" Beare thinks that the expression was intended to be “the title of the entire Gospel,” and he says that it conveys the thought “that this will be the story of the New Creation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Matthew is saying, then, that his book is the story "), _c('em', [_vm._v("of Jesus Christ.")]), _vm._v(" He does not use the full name "), _c('em', [_vm._v("Jesus Christ")]), _vm._v(" very often; indeed, this is the only place where it certainly occurs in this Gospel (it is read by many MSS in v. 18 and 16:21, but in each case omitted by others). Matthew probably saw it as appropriate in the heading of his book. His normal custom is to use the personal name "), _c('em', [_vm._v("Jesus,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn7",
      "id": "ft7"
    }
  }, [_vm._v("7")])])]), _vm._v(" which he does 150 times (Mark has this name 81 times, Luke 89, and John 237). We should perhaps notice that he uses the term only in narrative; no one in this Gospel addresses Jesus by his name. Matthew uses "), _c('em', [_vm._v("Christ")]), _vm._v(" only 17 times (Mark 7, Luke 12, and John 19). The word is, of course, a title; it means “anointed” and is the Greek way of referring to “Messiah.” The title was used so often by Christians that in time it came to be a proper name, but Matthew’s sparing use of it probably reflects the fact that this was not the case in Jesus’ lifetime."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn8",
      "id": "ft8"
    }
  }, [_vm._v("8")])]), _vm._v(" It "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("surely has messianic significance in the way this Evangelist uses it. Normally he has the definite article with the name "), _c('em', [_vm._v("Jesus,")]), _vm._v(" but its omission here in the heading to the book should not unduly surprise us (he omits the article with this name in all 19 times).")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("He goes on to speak of Jesus as the "), _c('em', [_vm._v("son of David;"), _c('sup')])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#fn9",
      "id": "ft9"
    }
  }, [_vm._v("9")])]), _vm._v(" he was of royal descent. Matthew uses the name of the great king 17 times, which is more than in any other book of the New Testament (next is Luke with 13). The expression “son of David” is probably a messianic title."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn10",
      "id": "ft10"
    }
  }, [_vm._v("10")])]), _vm._v(" David was the greatest of the kings of Israel. Since he was a mighty warrior, the title would have pointed to a conquering Messiah, one who would destroy the enemies of Israel and establish God’s kingdom with its capital at Jerusalem. It may well be that its militaristic associations account for the sparing use of the title among the Christians. To have made it central would have been to invite misunderstanding among those who dwelt on David’s military feats. Matthew has "), _c('em', [_vm._v("son of David")]), _vm._v(" 9 times (one referring to Joseph, 1:20; Mark and Luke each have it 3 times, and no other New Testament writer uses it). Its use here shows that Matthew plans to bring out what is meant by the Davidic Messiah. Interestingly, he uses it most frequently when people are appealing to Jesus for help (9:27; 15:22; 20:30-31). But it also appears in the story of the triumphal entry (21:9, 15), indicating that Matthew is not unaware of the royal associations of the term. His book is to be about one who fulfilled all that is meant in being the descendant of Israel’s greatest king."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn11",
      "id": "ft11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jesus was also the "), _c('em', [_vm._v("son of Abraham,")]), _vm._v(" “to whom the divine promises were first given and with whom ‘sacred history’ may be said to have begun” (Tasker). It was Abraham with whom God made the covenant that set Israel apart in a special sense as the people of God (Gen. 12:2-3; 15:17-21; 17:1-14). All Israelites took pride in being descendants of the great patriarch, and the Christians were especially fond of him as the classic example of one who believed (Paul brings this out particularly in Romans). His Hebrew name means “father of a multitude” (Gen. 17:5), and it had been prophesied that all nations would be blessed through him (Gen. 12:3)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn12",
      "id": "ft12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("We find the idea of a universal blessing at the end of this Gospel as well as at the beginning (28:19). In combining David and Abraham Matthew is drawing attention to two strands in Jesus’ Hebrew ancestry and implying that he fulfilled all that would be expected in a Messiah with such connections.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-8"
    }
  }, [_c('strong', [_vm._v("A. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENEALOGY OF")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESUS")]), _vm._v(", 1:2-17")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("2")]), _vm._v("Abraham fathered Isaac, and Isaac fathered Jacob, and Jacob fathered Judas and his brothers, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("3")]), _vm._v("and Judas fathered Phares and Zara from Thamar, and Phares fathered Esrom, and Esrom fathered Aram, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("4")]), _vm._v("and Aram fathered Aminadab, and Aminadab fathered Naasson, and Naasson fathered Salmon, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("5")]), _vm._v("and Salmon fathered Boes from Rachab, and Boes fathered Jobed from Ruth, and Jobed fathered Jessai, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("6")]), _vm._v("and Jessai fathered David the king.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_vm._v("And David fathered Solomon from the wife of Ourias, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("7")]), _vm._v("and Solomon fathered Roboam, and Roboam fathered Abia, and Abia fathered Asaph, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("8")]), _vm._v("and Asaph fathered Josaphat, and Josaphat fathered Joram, and Joram fathered Ozias, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("9")]), _vm._v("and Ozias fathered Joatham, and Joatham fathered Achaz, and Achaz fathered Ezekias, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("10")]), _vm._v("and Ezekias fathered Manasses, and Manasses fathered Amos, and Amos fathered Josias, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("11")]), _vm._v("and Josias fathered Jechonias and his brothers at the removal to Babylon.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("12")]), _vm._v("And after the removal to Babylon Jechonias fathered Salathiel, and Salathiel fathered Zorobabel, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("13")]), _vm._v("and Zorobabel fathered Abioud, and Abioud fathered Eliakim, and Eliakim fathered Azor, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("14")]), _vm._v("and Azor fathered Sadok, and Sadok fathered Achim, and Achim fathered Elioud, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("15")]), _vm._v("and Elioud fathered Eleazar, and Eleazar fathered Matthan, and Matthan fathered Jacob, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("16")]), _vm._v("and Jacob fathered Joseph the husband of Mary, from whom was fathered Jesus who is called Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("17")]), _vm._v("All the generations from Abraham to David were fourteen generations, and from David to the removal to Babylon were fourteen generations, and from the removal to Babylon to the Christ were fourteen generations.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Matthew begins with a genealogy. This seems to us a strange way to begin a book, but the Jews were very interested in records of descent. There are many examples of this in the Old Testament, the early chapters of 1 Chronicles forming a notable example (Matthew’s genealogy seems to depend on 1 Chronicles 1-3, with a little help from Ruth 4; from Zerubbabel on the source is unknown — perhaps it was a family record). Nearer to New Testament times Josephus begins his autobiography by tracing the names of his ancestors, whom, he says, “I cite as I find it recorded in the public registers” ("), _c('em', [_vm._v("Life")]), _vm._v(" 1); his reference to the “public registers” is significant and points to widespread interest. Jesus’ genealogy shows that he is of royal descent.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Matthew takes his genealogy back no farther than Abraham (Luke goes back to Adam). From Abraham to David the genealogy is much the ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("same as in Luke, though, of course, the two arrange the names differently: Luke goes from son to father and Matthew from father to son. The striking differences in the genealogies from David on present a difficult problem. Some commentators suggest that Matthew gives us the genealogy of Joseph (the legal father) and Luke that of Mary (the actual line). This is unlikely, for genealogies were not reckoned through the mother (though, of course, we must reckon with the fact that we have no information about what would happen when there was no human father). In any case Luke speaks of “Joseph the son of Eli” (Luke 3:23), which certainly does not read as though he were giving Mary’s genealogy. Another supposition is that there had been a levirate marriage when Eli died childless; Jacob, with the same mother but a different father, married the widow, and Joseph was his son. This is ingenious, but it lacks evidence. The best suggestion is that Matthew’s list represents the legal descendants of David, those who would actually have reigned had the kingdom continued, while Luke gives the descendants of David in the line to which Joseph belonged."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn13",
      "id": "ft13"
    }
  }, [_vm._v("13")]), _vm._v(" But we have no way of being certain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A feature of Matthew’s genealogy is his arrangement, as he tells us, in three groups of fourteen (v. 17). The reason for this is not clear, but it must have been important because Matthew has to omit some names to get his numbers. His second group lacks Ahaziah, Joash, and Amaziah after Joatham (v. 9),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn14",
      "id": "ft14"
    }
  }, [_vm._v("14")])]), _vm._v(" and his third group has only thirteen (since it covers some 500 years, there have clearly been omissions)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn15",
      "id": "ft15"
    }
  }, [_vm._v("15")])]), _vm._v(" The omissions need not worry us since “father” might be used when speaking of any descendants and not only those in the immediate family (e.g., 3:9)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn16",
      "id": "ft16"
    }
  }, [_vm._v("16")])]), _vm._v(" As it stands "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("the list certainly highlights Abraham the founder of the line, David the ideal king, and the exile to Babylon. The fourteens may come about through gematria, which takes the numbers signified by the letters as significant. Thus many interpreters point out that the numbers indicated by the letters of the Hebrew word for David add up to fourteen and detect an emphasis on the royal kingship which reaches its climax in Jesus. A less likely suggestion is that three times fourteen (= 6 × 7) means six weeks of people leading up to the age of the Messiah. Diétrich understands fourteen (2 × 7) as “the symbol of plenitude, of something complete.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("It is unusual, though not unexampled (see 1 Chron. 2:4; 3:5), to find names of women in a genealogy, but here we have four. In Jewish writings it is not uncommon to find four women singled out for special mention: Sarah, Rebecca, Rachel, and Leah. But Matthew’s four — Tamar, Rahab, Ruth, and Bathsheba — are probably all Gentiles; and since Ruth was a Moabitess, we should not overlook the fact that to the tenth generation a Moabite was not to be admitted to the congregation (Deut. 23:3). Three of the four are of morally dubious reputation. Matthew is surely saying that the gospel is for all people, not Jews only, and that the gospel is for sinners. It is a sinful world, and Matthew is writing about grace."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn17",
      "id": "ft17"
    }
  }, [_vm._v("17")]), _vm._v(" Stendahl thinks the mention of these women is a preparation for the “holy irregularity” of the virgin birth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The comparative disuse in modern times of the verb “beget” presents a problem in translation; Matthew’s verb denotes the action of the male parent, but the repetition of “begot” sounds strange today. "), _c('em', [_vm._v("NRSV")]), _vm._v(" and others render it “was the father of,” which refers to a state rather than an event. I have used the word “fathered,” which is not an ideal translation but gives us the general idea. Throughout the genealogy Matthew has the article with the names; this appears to have been a colloquial usage since it is neither the classical nor the normal New Testament custom (cf. BDF, 260). He mostly uses the forms of names in LXX rather than those in the Hebrew and seems to depend largely on 1 Chronicles 2-3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("2-6.")]), _vm._v(" Matthew here employs the form Ἰαϰώβ"), _c('strong'), _vm._v(" for Jacob, a form he uses for the father of Joseph in verses 15 and 16 and which elsewhere in the New Testament always denotes the patriarch."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn18",
      "id": "ft18"
    }
  }, [_vm._v("18")])]), _vm._v(" Judah’s "), _c('em', [_vm._v("brothers")]), _vm._v(" do not "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("feature in the genealogy, but they are important in the Old Testament. And brotherhood is an important concept for Matthew (he has the word “brother” 39 times, the same number as in 1 Corinthians and the most in any book in the New Testament apart from Acts, which has it 57 times). Thamar is the first woman to be mentioned in the genealogy;"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn19",
      "id": "ft19"
    }
  }, [_vm._v("19")]), _vm._v(" this is curious not only because she was a woman but because the children were conceived out of wedlock. This is the first point at which the genealogy differs from that in Luke. There Esrom’s son is Arni, Arni’s son is Admin, and Admin’s son is Aminadab (Matthew omits Admin and agrees with Ruth 4:19-20). Only here do we find Rahab featured in David’s ancestry. This fact is not recorded elsewhere in Scripture, nor in other Jewish writings."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn20",
      "id": "ft20"
    }
  }, [_vm._v("20")])]), _vm._v(" And the information about Ruth is not found in Chronicles; it is recorded in Ruth 4:13-22. When he comes to David, Matthew adds "), _c('em', [_vm._v("the king;")]), _vm._v(" this is where kingship is attained in the line he is tracing. Now Matthew is very interested in kingship and uses the word “king” 22 times, more than any other book in the New Testament. He uses it in a variety of ways, referring to King Herod, the king in a parable, and the Son of man as King on Judgment Day. Here he is making it clear that there is royalty in Jesus’ line so that he is rightly called “King of the Jews” (2:2; 27:11, 29, 37, 42).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("7-11.")]), _vm._v(" Problems arise in that the name of Jehoiakim is omitted and there is no mention of any brothers of Jeconiah (= Jehoiachin) in the Old Testament. But Matthew’s interest in brothers accounts for the inclusion of the reference even though we do not know where he got it (Ridderbos thinks that they were mentioned not because of their importance but because of their unimportance! It is that kind of genealogy). The second section of the genealogy concludes with the deportation to Babylon,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn21",
      "id": "ft21"
    }
  }, [_vm._v("21")])]), _vm._v(" a very significant happening in the history of the nation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("12-16.")]), _vm._v(" Had Jehoiakim been included, we would have had fourteen names in this third section, so the omission is curious."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn22",
      "id": "ft22"
    }
  }, [_vm._v("22")])]), _vm._v(" The genealogy concludes with Joseph, described as "), _c('em', [_vm._v("the husband of Mary")]), _vm._v(" but not as the father of Jesus. Matthew will tell us a little later that the child was conceived as a result of the activity of the Holy Spirit (v. 20)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn23",
      "id": "ft23"
    }
  }, [_vm._v("23")])]), _vm._v(" The passive form here is probably the “divine passive,” indicating an activity of God; "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("it certainly points to something different from what precedes and it prepares us for the narrative of the virgin birth. That the virginal conception is in mind in the genealogy is probably another way of bringing out the truth that Jesus was the “son of David.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn24",
      "id": "ft24"
    }
  }, [_vm._v("24")]), _vm._v(" There is another passive in verse 20, and twice Matthew speaks of Jesus’ conception as due to the Holy Spirit (vv. 18, 20). He also cites prophecy to show the real significance of the child who was to be born (vv. 22-23); further, he tells us that Mary was a virgin (v. 23) and that Joseph had no sexual relations with her before the birth of Jesus (v. 25). All this combines to make it clear that Matthew is writing about the coming into the world not simply of another baby, but of the very Son of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("17.")]), _vm._v(" Matthew explains what he is about by referring to his three groups of fourteen. Clearly the number is significant for him, but unfortunately he does not explain why. But the note of fulfilment is strong, and perhaps Marshall D. Johnson gives us the answer: “The function of the genealogy — the note of fulfillment — explains the lack of a precise and exact parallel with contemporary sources: "), _c('em', [_vm._v("the two genealogies of Jesus in the NT are the only extant Messianic genealogies")]), _vm._v(" which are written to prove that the Messiah has come.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn25",
      "id": "ft25"
    }
  }, [_vm._v("25")])]), _vm._v(" We should perhaps bear in mind also the point made by L. Finkelstein that the number fourteen was regarded as significant in contemporary Judaism. He says, “The number, ‘fourteen’, is not accidental. It corresponds to the number of high priests from Aaron to the establishment of Solomon’s Temple; the number of high priests from the establishment of the Temple until Jaddua, the last high priest mentioned in Scripture. It is clear that a mystic significance attached to this number, in both the Sadducean and the Pharisaic traditions.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn26",
      "id": "ft26"
    }
  }, [_vm._v("26")])]), _vm._v(" Matthew would have been aware of this and may be producing an argument that would impress Jews.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-9"
    }
  }, [_c('strong', [_vm._v("B. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRTH OF")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESUS")]), _vm._v(", 1:18-25")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotet"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("18")]), _vm._v("Now the birth of Jesus Christ was like this. Mary his mother was engaged to Joseph, but before they came together she was found to be pregnant by the Holy Spirit. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("19")]), _vm._v("And Joseph her husband, being a just man and not wishing to expose her publicly, decided to divorce her secretly. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("20")]), _vm._v("But "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("when he had made up his mind to do this, look, an angel of the Lord appeared to him in a dream and said, “Joseph, son of David, don’t be afraid to take Mary your wife, for what has been conceived in her is from the Holy Spirit. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("21")]), _vm._v("She will give birth to a son, and you will call his name Jesus; for he will save his people from their sins.” "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("22")]), _vm._v("Now all this happened so that it might be fulfilled which was spoken by the Lord through the prophet, saying, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("23")]), _vm._v("“Look, the virgin will conceive and bear a son, and they will call his name ‘Emmanuel,’ which means, ‘God with us.’” "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("24")]), _vm._v("And Joseph, when he had awakened from his sleep, did as the Lord’s angel directed and took his wife; "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("25")]), _vm._v("and he had no intercourse with her until she had given birth to a son. And he called his name Jesus.")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "indent-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Matthew tells the story of the birth of Jesus from the standpoint of Joseph rather than that of Mary, as Luke does. Luke accordingly has such stories as the appearance of the angel to Mary, but Matthew simply says that Mary became pregnant due to an activity of the Holy Spirit and goes on to tell his readers what Joseph did. It would have been expected that he would have divorced Mary, but an angelic visitor told him not to do so. Matthew tells us how Joseph obeyed the angel. Matthew’s account is clearly quite independent of that of Luke, but it emphasizes equally the virgin birth."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn27",
      "id": "ft27"
    }
  }, [_vm._v("27")]), _vm._v(" We should notice (a) the emphasis on the place of Joseph, (b) the important place of divine guidance given in dreams, and (c) the repeated references to the fulfilment of prophecy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("18.")]), _vm._v(" Matthew has a kind of subheading to let the reader know that he will now tell us about the birth"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn28",
      "id": "ft28"
    }
  }, [_vm._v("28")])]), _vm._v(" of "), _c('em', [_vm._v("Jesus Christ")]), _vm._v(" (see on v. 1; this seems to be the probable reading, though some MSS have “Jesus” or “Christ”). The formal name and title are suited to the opening of the narrative proper, and the unusual use of the article points back to the Jesus Christ already referred to."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn29",
      "id": "ft29"
    }
  }, [_vm._v("29")])]), _vm._v(" He does not tell the reader who Joseph and Mary were; evidently he can presume that they will know this. Similarly, he does not speak explicitly of the virginal conception; that, too, he evidently presumes is known. The word I have translated "), _c('em', [_vm._v("engaged"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn30",
      "id": "ft30"
    }
  }, [_vm._v("30")])])]), _vm._v(" indicates a firm "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("commitment, normally undertaken a year before marriage. During that year the girl remained with her own family, but the tie established was a strong one and was really the first part of marriage. A betrothed woman could be punished as an adulteress (Deut. 22:23-24; the punishment of “a virgin who is not betrothed” was different, vv. 28-29). The second part took place when the man took the woman to his home (cf. v. 20; cf. also 25:1-13). That Mary became pregnant "), _c('em', [_vm._v("before they came together"), _c('sup')])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#fn31",
      "id": "ft31"
    }
  }, [_vm._v("31")])]), _vm._v(" was thus very serious, as Joseph’s attitude makes clear. Some translations read “she found out” ("), _c('em', [_vm._v("GNB, REB),")]), _vm._v(" but the passive more likely refers to Joseph’s becoming aware of the situation. The whole story is written from his point of view. But before speaking of Joseph’s attitude Matthew explains that the pregnancy was due to an activity of the Holy Spirit. He speaks with reverent reserve and says no more."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn32",
      "id": "ft32"
    }
  }, [_vm._v("32")])]), _vm._v(" The Spirit is called “Holy,” an adjective not applied to him in Philo or Josephus (so BAGD, 5c). The idea that the Spirit is holy is distinctively Christian. Matthew often has the expression without the article (as here)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn33",
      "id": "ft33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("19.")]), _vm._v(" Joseph, Mary’s husband,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn34",
      "id": "ft34"
    }
  }, [_vm._v("34")])]), _vm._v(" is called "), _c('em', [_vm._v("just,")]), _vm._v(" which probably means that he was careful in his observance of the law."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn35",
      "id": "ft35"
    }
  }, [_vm._v("35")])]), _vm._v(" The passage that covered "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("the situation was that of the betrothed woman who has had sexual intercourse (Deut. 22:23-27). Where the woman is a consenting partner, both are to be put to death (vv. 23-24); where she has been violated, only the guilty man is to be executed (vv. 25-27). But the violation has taken place: the girl is no longer a virgin. Angelo Tosato cites evidence that she is no longer eligible to be married to her betrothed; she must be given a bill of divorce."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn36",
      "id": "ft36"
    }
  }, [_vm._v("36")]), _vm._v(" Joseph, being "), _c('em', [_vm._v("just,")]), _vm._v(" saw that he was unable to consummate the marriage, but he did not want"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn37",
      "id": "ft37"
    }
  }, [_vm._v("37")])]), _vm._v(" to be harsh. Perhaps we should say that for Joseph being just before God included an element of mercy (the “just man” is compassionate, Ps. 37:21). Probably also he preferred to act in a way that would avoid an open scandal. He could have made a public display of his indignation by taking Mary before the law court and making an example of her."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn38",
      "id": "ft38"
    }
  }, [_vm._v("38")])]), _vm._v(" But his concern for the law did not lead him to the conclusion that he must humiliate the young lady who, he thought, had offended. He preferred to "), _c('em', [_vm._v("divorce her secretly.")]), _vm._v(" Divorce was no great problem for an Israelite man: he simply had to give the lady “a bill of divorce” before two witnesses and send her away (the procedure is given in Deut. 24:1)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn39",
      "id": "ft39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("20.")]), _vm._v(" But"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn40",
      "id": "ft40"
    }
  }, [_vm._v("40")])]), _vm._v(" he did not go through with it. He gave the matter thought, and the aorist indicates that he apparently came to a conclusion: he "), _c('em', [_vm._v("had made up his mind"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn41",
      "id": "ft41"
    }
  }, [_vm._v("41")])])]), _vm._v(" (despite "), _c('em', [_vm._v("GNB,")]), _vm._v(" “While he was thinking about this”). "), _c('em', [_vm._v("Look")]), _vm._v(" is a favorite interjection of Matthew’s (62 times out of 200 in the NT); it enlivens a narrative and makes what follows more vivid. An "), _c('em', [_vm._v("angel")]), _vm._v(" appeared. The word means a messenger: occasionally in the New Testament it is used of a human messenger (Luke 7:24), but more often it refers to a messenger from God, as is made clear here by the addition "), _c('em', [_vm._v("of the Lord.")]), _vm._v(" Curiously, when it is used in the singular in the New Testament it almost always lacks the article, as here (though cf. v. 24), but the plural "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("form “the angels of God” invariably has it except in one quotation from the Old Testament (in Heb. 1:6). Matthew specifies that this angel appeared to Joseph "), _c('em', [_vm._v("in a dream,")]), _vm._v(" an expression used 6 times by Matthew and by no one else in the New Testament."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn42",
      "id": "ft42"
    }
  }, [_vm._v("42")]), _vm._v(" Nothing is said about the appearance of the angel or anything he did; attention is concentrated on his message. He addresses Joseph as "), _c('em', [_vm._v("son of David,")]), _vm._v(" an expression used of Jesus in verse 1 (where see note). The expression is one of dignity, and Matthew perhaps records it as emphasizing the royal line of Jesus. "), _c('em', [_vm._v("Don’t be afraid")]), _vm._v(" does not necessarily indicate fear; the word may be used in the sense “shrink from doing something,” and it is this sense that is required here (cf. BAGD, φοβέω, 1.c). We might have expected the present, giving the sense “Stop being afraid,” but the aorist may give the sense “Never fear.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn43",
      "id": "ft43"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('em', [_vm._v("Take")]), _vm._v(" is used of receiving one’s wife into one’s home a number of times (BAGD), and this is obviously the meaning. Notice that Mary is called Joseph’s "), _c('em', [_vm._v("wife.")]), _vm._v(" Davies and Allison observe that throughout chapters 1 and 2 “It is Joseph who does what needs to be done.” They think that this can be explained “by a christological interest: by his actions, Joseph, the Davidid, proves that he has made Jesus his own.” The angel gives a reason"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn44",
      "id": "ft44"
    }
  }, [_vm._v("44")])]), _vm._v(" for Joseph’s reception of Mary: the Holy Spirit has brought about the conception. The verb is that normally used of the action of the male parent (= “that which was begotten”), but it is sometimes used of the female, so that there is nothing very unusual about the expression. For "), _c('em', [_vm._v("Holy Spirit")]), _vm._v(" see on verse 18.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("21.")]), _vm._v(" Mary’s child"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn45",
      "id": "ft45"
    }
  }, [_vm._v("45")])]), _vm._v(" will be "), _c('em', [_vm._v("a son,")]), _vm._v(" and Joseph is instructed to "), _c('em', [_vm._v("call his name Jesus.")]), _vm._v(" This is a Hebraic construction; it would have been possible to say simply, “call him — .” By giving the name Joseph officially accepted the child (cf. “I have called you by name, you are mine,” Isa. 43:1); this gave the child the status of a descendant of David."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn46",
      "id": "ft46"
    }
  }, [_vm._v("46")])]), _vm._v(" On this occasion the name is not to be left to the discretion of the parent, for this child is special and has a destiny that is to be expressed in the meaning of the name. So the angel goes on to say, "), _c('em', [_vm._v("he")]), _vm._v(" (the word is emphatic: “He and no other”) "), _c('em', [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("will save his people from their sins")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v(" (cf. Ps. 130:8). The word "), _c('em', [_vm._v("save")]), _vm._v(" may mean deliver from troubles and afflictions of various kinds, but the addition here shows that what is in mind is the salvation that reckons with the plight in which people involve themselves by their evil deeds."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn47",
      "id": "ft47"
    }
  }, [_vm._v("47")]), _vm._v(" "), _c('em', [_vm._v("People"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn48",
      "id": "ft48"
    }
  }, [_vm._v("48")])])]), _vm._v(" may be used of the populace generally, but it is often used more specifically of the people of God, and this in the sense of ancient Israel or of Christians. Matthew does not use the word “sin”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn49",
      "id": "ft49"
    }
  }, [_vm._v("49")])]), _vm._v(" very often (7 times), but the expression here shows that he regarded it as an important concept. Jesus came to deal with "), _c('em', [_vm._v("sins,")]), _vm._v(" and his name gives expression to a very significant truth. Barclay aptly says, “Jesus was not so much The Man born to be King, as He was The Man born to be Saviour.” We should not miss the point that the note of grace is struck so early in this Gospel. The impression is sometimes given that Matthew stresses upright living whereas Paul speaks of saving grace. It is true that these two writers have their own emphases, and we should not interpret either as though he were setting forth the other’s thoughts. But neither should we overlook the fact that all the New Testament writers refer to the same Savior. And all stress the importance of grace. Matthew will later return to the idea that Jesus brings forgiveness (e.g., 20:28; 26:28).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("22.")]), _vm._v(" It is characteristic of Matthew to appeal to prophecy and to see in it a fulfilment of what God had said long ago. "), _c('em', [_vm._v("All"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn50",
      "id": "ft50"
    }
  }, [_vm._v("50")])]), _vm._v(" this,")]), _vm._v(" he says, happened so that"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn51",
      "id": "ft51"
    }
  }, [_vm._v("51")])]), _vm._v(" prophecy would be fulfilled. This formula, when appealing to the fulfilment of prophecy, is found again (sometimes with small variations) in 2:15, 17, 23; 4:14; 8:17; 12:17; 13:35; 21:4; 26:56; 27:9.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Matthew is very interested in the way the ancient prophecies found their fulfilment in Jesus. But though the formula is common in Matthew, the inclusion of "), _c('em', [_vm._v("all")]), _vm._v(" is not (again in 26:56); here Matthew emphasizes that all the items mentioned were fulfilled and not only some of them. Notice that he speaks of the words in question not as spoken by the prophet, but "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("as spoken by the Lord through the prophet. Matthew takes inspired prophecy very seriously."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn52",
      "id": "ft52"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("23.")]), _vm._v(" The prophecy comes from Isaiah 7:14 and is exactly as in LXX, except that the verb "), _c('em', [_vm._v("call")]), _vm._v(" is plural in place of Isaiah’s singular. For "), _c('em', [_vm._v("Look")]), _vm._v(" see on verse 20. The definite article points to a particular "), _c('em', [_vm._v("virgin."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn53",
      "id": "ft53"
    }
  }, [_vm._v("53")])])]), _vm._v(" The point of the plural is not obvious; it may be a way of linking both parents in the giving of the name, or perhaps of associating other people with this. "), _c('em', [_vm._v("Emmanuel")]), _vm._v(" is found here only and is the transliteration of the Hebrew word meaning "), _c('em', [_vm._v("God with us,")]), _vm._v(" as Matthew goes on to explain."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn54",
      "id": "ft54"
    }
  }, [_vm._v("54")])]), _vm._v(" As far as our information goes, nobody ever called Jesus “Emmanuel”; it was not the child’s name in the same sense as “Jesus” was. Matthew surely intends his readers to understand that “Emmanuel” was his name in the sense that all that was involved in that name found its fulfilment in him."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn55",
      "id": "ft55"
    }
  }, [_vm._v("55")])]), _vm._v(" The quotation and the translation of the Hebrew name underline the fact that in Jesus none less than God came right where we are. And at the end of this Gospel there is the promise that Jesus will be with his people to the end of the age (28:20) — God with us indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("24.")]), _vm._v(" In due course Joseph woke up and did what the angel told him to do. "), _c('em', [_vm._v("Angel")]), _vm._v(" has the definite article (unusually; see on v. 20), which signifies “the aforementioned angel.” Matthew picks out the central part of the angelic command: Joseph "), _c('em', [_vm._v("took his wife,")]), _vm._v(" that is, publicly accepted Mary as his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("25.")]), _vm._v(" But though he married Mary, they had no sexual relations"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn56",
      "id": "ft56"
    }
  }, [_vm._v("56")])]), _vm._v(" before "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("the birth of the son. "), _c('em', [_vm._v("Until")]), _vm._v(" is a Matthean word;"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn57",
      "id": "ft57"
    }
  }, [_vm._v("57")]), _vm._v(" the passage makes it clear that there was no sexual intercourse before the birth of the baby. It does not say whether or not this took place thereafter, but the natural way of taking the passage would indicate that it did (Allen holds that the imperfect tense here “is against the tradition of perpetual virginity”). It is also true that in both Old and New Testaments such intercourse is approved and viewed as an integral part of marriage (Gen. 1:28; 9:1; Prov. 5:18; 1 Cor. 7:3-5). The singular "), _c('em', [_vm._v("called")]), _vm._v(" almost certainly means “Joseph called” (though grammatically the subject of the verb might be “she”). The story is told throughout from his point of view; thus it is natural that it concludes with him naming the child Jesus. His naming of the child means that he adopted him legally.")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(". Kingsbury argues strongly that the canonical Gospels are to be understood as biographies, albeit “of the nature of ancient biography” rather than biography of the modern type ("), _c('em', [_vm._v("Matthew,")]), _vm._v(" pp. 9-13). But this is to ignore the fact that from the earliest days εὐαγγέλιον is applied to them; whatever else we may say about these books, they are “Jesus Christ’s good news” (Mark 1:1). Kingsbury shows a better appreciation of what Matthew is doing when he writes, “Matthew’s document is of the nature of a ‘gospel,’ that is to say, a kerygmatic story. Its purpose is, again, to announce the news that saves or condemns which is revealed in and through Jesus Messiah, the Son of God, and is proclaimed first to Israel and then to the gentiles to the effect that in him the eschatological rule of God has drawn near to humankind” ("), _c('em', [_vm._v("Matthew,")]), _vm._v(" p. 29).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(". βίβλος, here only in Matthew, occurs 10 times in the New Testament. The original form was βύβλος, which denoted “the Egyptian papyrus, Cyperus Papyrus” (LSJ; it suggests that the form βιβλ- arose “by assimilation in βίβλιον”). It lacks the article since this is a heading (cf. M, I, p. 82). In the plural βίβλος came to denote strips of the plant, which were made into the writing material papyrus. Thus it came to mean a roll of papyrus, a book.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(". γένεσις has about it the idea of “origin” or “source” (BAGD notes its use “in the subscription of the infancy narrative of Pythagoras”); it is understood in this way by most translators and commentators, who often translate it by “genealogy.” But its use in Genesis 2:4 is surely in the sense “This is the account of the heavens and the earth when they were created” ("), _c('em', [_vm._v("NIV; NRSV’s")]), _vm._v(" “These are the generations of the heavens and the earth …” is scarcely intelligible); “account” or “history” is the meaning. It occurs also in Genesis 5:1, where "), _c('em', [_vm._v("NIV")]), _vm._v(" has “This is the written account of Adam’s line.” The emphasis in Genesis 5:1 is on Adam who began the line, but in Matthew it is on Jesus in whom the line reached its consummation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(". Davies and Allison draw attention to the earliest MSS of LXX and to early writers like Justin and Origen for this title.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(". See Bonnard for the idea that the words form a heading for both the genealogy and the whole book. Fenton regards it as telescopic, referring first to the genealogy, then the birth, then the life-story, and finally “the whole new creation which begins at the conception of Jesus and will be completed at his second coming.” R. L. Overstreet writes, “it seems best to understand it as not being a reference to the birth alone of Christ, but rather as an introduction to his life and acts. In other words, the phrase seems to introduce the complete book of Matthew” ("), _c('em', [_vm._v("GTJ,")]), _vm._v(" 2 [1981], p. 306). See also Davies and Allison, and Davies, "), _c('em', [_vm._v("SM,")]), _vm._v(" pp. 67ff.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Cf. W. Marxsen, “By means of this phrase therefore the work is presented almost as ‘Holy Scripture’ — by analogy with the Old Testament — to which one can appeal and from which one can take one’s bearings if one wishes to observe or teach others to observe what Jesus commanded” ("), _c('em', [_vm._v("Introduction to the New Testament")]), _vm._v(" [Philadelphia, 1974], p. 151).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v(". "), _c('em', [_vm._v("Jesus")]), _vm._v(" is the Latin form of the name = Ἰησοῦς, the Greek form of the Hebrew "), _c('em', [_vm._v("Jeshua,")]), _vm._v(" a shorter form of "), _c('em', [_vm._v("Jehoshua,")]), _vm._v(" which means “Yahweh is salvation.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(". See further my "), _c('em', [_vm._v("New Testament Theology")]), _vm._v(" (Grand Rapids, 1986), pp. 125-26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(". Both "), _c('em', [_vm._v("son of David")]), _vm._v(" and "), _c('em', [_vm._v("son of Abraham")]), _vm._v(" lack the article; this is probably because we are still involved in the title of the book. υἱός can mean “son” in the sense of a direct male offspring, or, as here, of a more remote male descendant. It may also be used of followers (as in “the sons” of the Pharisees, 12:27), or of members of a large group (cf. “the sons of men,” Mark 3:28), or of those who share similar ideas or experiences such as “the sons of the kingdom,” 8:12), or of “the sons of light” (Luke 16:8). It is, of course, frequently used of Jesus, as in a special sense “the Son of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(". It occurs in the "), _c('em', [_vm._v("Psalms of Solomon,")]), _vm._v(" “raise up to them their king, the Son of David” (17:23). It is not found often in pre-Christian days, but in post-Christian times it was common as a designation of the Messiah (SBk, I, p. 525). That this goes back to the time of Jesus seems clear from 22:41-45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v(". G. Dalman has an important discussion of “Son of David” in "), _c('em', [_vm._v("The Words of Jesus")]), _vm._v(" (Edinburgh, 1902), pp. 316-24. See also my "), _c('em', [_vm._v("New Testament Theology,")]), _vm._v(" pp. 126-27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(". Many interpreters view this as the wrong way to interpret Gen. 12:3, but Robinson points out that it “goes back at least to the LXX and dominated all later exegesis.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(". See J. G. Machen, "), _c('em', [_vm._v("The Virgin Birth of Christ")]), _vm._v(" (London, 1958), p. 204.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(". From his understanding of 1 Chronicles 3:11-12 (LXX) Allen argues that the three omitted are Joash, Amaziah, and Azariah. This involves accepting Οζεια or Οζιάς (which normally in LXX = Uzziah) in 1 Chronicles 3:11 (Rahlfs reads Οζοξια, which normally in LXX = Ahaziah), and assuming that Matthew or a copyist has passed from Οζεια to Uzziah’s son, Jotham. "), _c('em', [_vm._v("AB")]), _vm._v(" accepts this view and further posits “an editor assimilating Matthew’s list to the LXX record.” Nothing appears to be gained by this hypothesis, and it is simpler to see an omission of Ahaziah, Joash, and Amaziah. Marshall D. Johnson argues for an accidental scribal omission of the names Azariah, Joash, and Amaziah and “that accident was turned into virtue — that after the accidental omission the scribe discovered a second pattern of fourteens which came to determine the structure of the genealogy” (The "), _c('em', [_vm._v("Purpose of the Biblical Genealogies")]), _vm._v(" [Cambridge, 1969], p. 182).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Schweizer holds that, since ancient reckoning always included the first and last names in series, we should probably understand the sequence as “from Abraham to David, fourteen; from David (counted a second time) to Josiah, the last free king, fourteen; from the first king of the captivity, Jehoiakim, to Jesus, fourteen.” Or we may be meant to count Jeconiah twice, once as the last name in the second division and once as the first name in the third. Another suggestion is that we should take one “Jeconiah” as really “Jehoiakim,” who is not otherwise mentioned in the list.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v(". That the Jews shortened genealogies is seen by comparing Ezra 7:1-5 with 1 Chronicles 6:3-15 (Ezra has even omitted his own father!). Overstreet comments, “Apparently to the Jewish mind this was a proper thing to do, and it is not unusual to find Matthew omitting names in his genealogy” ("), _c('em', [_vm._v("GTJ,")]), _vm._v(" 2 [1981], p. 310).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(". “The number and the choice are intentional, not accidental. The Evangelist has a point to make through them. He wishes to show that the genealogy of Christ, embracing the whole history of Israel, bears witness not only to its high points but also to the sin and unworthiness which run through this history even at its high points, i.e., in the age of the patriarchs and the house of David. … the history of the people elected to be the people of the Messiah is one of grace rather than glory” (G. Kittel, "), _c('em', [_vm._v("TDNT,")]), _vm._v(" III, p. 1). Barclay envisions a grand sweep, “In his genealogy Matthew shows us the royalty of kingship gained; the tragedy of freedom lost; the glory of liberty restored. And that, in the mercy of God, is the story of mankind, and of each individual man.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(". Cf. BAGD, “This, the un-Grecized form of the OT, is reserved for formal writing, and esp. for the patriarch”; for other people the Grecized form Ἰάϰωβος is usual (Matthew has it 6 times).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Just as γεννάω is normally used of the action of the father, so ἐϰ is used of the mother.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft20",
      "id": "fn20"
    }
  }, [_vm._v("20")]), _vm._v(". See Marshall D. Johnson, "), _c('em', [_vm._v("The Purpose of the Biblical Genealogies,")]), _vm._v(" pp. 162-65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(". The genitive Βαβυλῶνος illustrates the indefiniteness of the genitive. The form denotes no more than “a Babylon-type removal” and could denote a removal to Babylon or from Babylon or even of Babylon. But our knowledge of history shows us that the meaning must be “to Babylon.” Moule sees this as a “strongly adjectival use” ("), _c('em', [_vm._v("IBNTG,")]), _vm._v(" p. 38).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft22",
      "id": "fn22"
    }
  }, [_vm._v("22")]), _vm._v(". One factor may be that the names Jehoiakim and Jehoiachin are both rendered Ιωαϰιμ in LXX.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v(". The Sinaitic Syriac MS reads “Joseph, to whom was betrothed Mary the virgin, begot Jesus who is called the Christ,” and this is occasionally accepted (as, e.g., by Moffatt). But Metzger’s discussion shows that there is no reasonable doubt that this reading should be rejected.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Cf. Patte, “A son of David is not someone primarily characterized by a certain biological descendance but someone whose existence has been brought about by the intervention of God. A child of David and of Abraham is someone who owes his or her origin "), _c('em', [_vm._v("(genesis)")]), _vm._v(" to God.” He notes that in 3:9 the Pharisees and Sadducees cannot really claim to be children of Abraham, and that God can raise up children to Abraham out of the very stones.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft25",
      "id": "fn25"
    }
  }, [_vm._v("25")]), _vm._v(". "), _c('em', [_vm._v("The Purpose of the Biblical Genealogies,")]), _vm._v(" p. 208 (Johnson’s italics). Cyrus H. Gordon has a note in which he points out that there are many examples in antiquity of people who claimed to have a divine father as well as a human father. He does not dispute that Jesus’ fatherhood was special, but simply points out that dual fatherhood did not sound as paradoxical in the first century as it does to us ("), _c('em', [_vm._v("JBL,")]), _vm._v(" 96 [1977], p. 101).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft26",
      "id": "fn26"
    }
  }, [_vm._v("26")]), _vm._v(". Cited in "), _c('em', [_vm._v("SM,")]), _vm._v(" pp. 303-4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(". Gundry holds that “We only have to suppose that Matthew had the traditions that later went into Luke 1-2 to see what happens under his artistry.” Matthew, he thinks, “turns the annunciation to Mary before her conceiving Jesus (Luke 1:26-38) into an annunciation to Joseph after her conceiving Jesus.” Plummer, by contrast, holds that neither narrative “can have been based on the other.” He finds “signs of historic reality” in the “delicacy and sobriety of both narratives” in sharp contrast to pagan legends, Jewish stories (as in the Book of Enoch), and Christian apocryphal Gospels (p. 4).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v(". For γένεσις see on verse 1. Here it signifies “coming into being” and thus “birth.” The δέ is continuative; it links the account with the preceding.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft29",
      "id": "fn29"
    }
  }, [_vm._v("29")]), _vm._v(". Most MSS read τοῦ δὲ Ἰησοῦ Χριστοί, but the article is very rare with Ἰησοῦς Χριστõς. Χρίστοῦ is read by a number of Western sources, but Metzger points out that this may be no more than an assimilation to the reading of the preceding sentence. Similarly, Ἰησοῦ (W) may conform this passage to the words of the angel (v. 21). It seems better to retain the harder reading.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(". μνηστεύω, elsewhere in the New Testament only in Luke 1:27; 2:5, signifies “woo and win, betroth” (BAGD). It was a binding arrangement, and the betrothed could be called “the wife” of her fiancé (Gen. 29:41; Deut. 22:23-24), as is the case with Mary here (v. 20); the young man could similarly be called the girl’s “husband” (e.g., Joel 1:8), as is Joseph here (v. 19). To break a betrothal, divorce proceedings were necessary. On the genitive absolute BDF remarks, “The harshest and at the same time rarest case is where the ‘antecedent’ follows as subject … but here the inserted infinitive with πρίν (with another subject) mitigates the ensuing anacolouthon, for which classical parallels may be found” (423[4]). The use of the genitive absolute when the participle could have agreed with a noun gives it emphasis (Robertson, pp. 1131-32).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft31",
      "id": "fn31"
    }
  }, [_vm._v("31")]), _vm._v(". συνέρχομαι, here only in Matthew, may be used of assembling but also “of coming together in a sexual sense”; it is used in the papyri in marriage contracts with the meaning “marry” (BAGD).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft32",
      "id": "fn32"
    }
  }, [_vm._v("32")]), _vm._v(". Bonnard points out that Luke speaks of the Spirit coming “upon” (ἐπί) Mary, but Matthew is “more reserved, more Jewish”; he indicates only that there was a miraculous conception without speaking of a movement of the Spirit toward or in Mary. Cf. Barclay, “… has come from the Holy Spirit.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v(". It is sometimes argued that the omission of the article points to the power rather than the person, but it is difficult to justify this from the usage. Turner points out further that the omission of the article in prepositional expressions, as here, does not make the word indefinite (M, III, pp. 175-76). Cf. "), _c('em', [_vm._v("AB,")]), _vm._v(" “In Aramaic at this time there was no differentiation between the definite and the indefinite article. The absence of the definite article in Greek at this point is therefore not significant.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft34",
      "id": "fn34"
    }
  }, [_vm._v("34")]), _vm._v(". The word is ἀνήρ, which Matthew uses only 8 times. It means “man” in contrast to woman, and thus “husband”; by contrast he uses ἄνθρωπος 112 times, which is more than in any other book in the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft35",
      "id": "fn35"
    }
  }, [_vm._v("35")]), _vm._v(". AS differentiates δίϰαιος (used here) from ἀγαθός in that this latter term in Rom. 5:7 “implies a kindliness and attractiveness not necessarily possessed by the δίϰαιος, who merely measures up to a high standard of rectitude” (sub ἀγαθός; under ἀγαθωσύνη he cites Armitage Robinson for the view that ἀ. represents “the kindlier, as διϰαιοσύνη the sterner, element in the ideal character”). David Hill holds that here it refers “quite simply to Joseph’s decision to observe the Jewish law faithfully and conscientiously” (ET, LXXVI [1964-65], p. 134). Matthew uses δίϰαιος 17 times, which is more than in any other New Testament book (next is Luke with 11) and equals the total in all the Pauline letters.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v(". "), _c('em', [_vm._v("CBQ,")]), _vm._v(" 41 (1979), pp. 547-51. The Mishnah says explicitly that the woman is “forbidden” to both the husband and the paramour ("), _c('em', [_vm._v("So")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("a")]), _vm._v(" 5:1).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft37",
      "id": "fn37"
    }
  }, [_vm._v("37")]), _vm._v(". The verb is θέλω (which Matthew uses 42 times, the most in any New Testament book). It conveys the notion of the exercise of the will, though sometimes this is attenuated to mere wishing. In New Testament times it seems not to have differed greatly from βούλομαι (the word rendered "), _c('em', [_vm._v("decided).")]), _vm._v(" ϰαί is probably used here in the sense “and yet” (BAGD, I.2.g) — Joseph as a pious upholder of the law might well have seen the right course as that of making a public example of an erring fiancée.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft38",
      "id": "fn38"
    }
  }, [_vm._v("38")]), _vm._v(". That is the force of the rare verb δειγματίζω, connected with δεῖγμα, “a proof,” “an example.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft39",
      "id": "fn39"
    }
  }, [_vm._v("39")]), _vm._v(". The bill of divorce must contain the formula “Lo, thou art free to marry any man,” or according to R. Judah, “Let this be from me thy writ of divorce and letter of dismissal and deed of liberation, that thou mayest marry whatsoever man thou wilt” ("), _c('em', [_vm._v("Gi")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ṭ")]), _vm._v(". 9:3). It should be signed by two or more witnesses ("), _c('em', [_vm._v("Gi")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ṭ")]), _vm._v(". 6:7).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft40",
      "id": "fn40"
    }
  }, [_vm._v("40")]), _vm._v(". δέ here has adversative force. The conjunction is found at the beginning of each of the verses 18-22, though with somewhat variable meaning. But at least it serves to link the various parts of the narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft41",
      "id": "fn41"
    }
  }, [_vm._v("41")]), _vm._v(". ἐνθυμέομαι occurs again in the New Testament only in 9:4. It has the meaning “reflect on, consider.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft42",
      "id": "fn42"
    }
  }, [_vm._v("42")]), _vm._v(". BAGD notes that the expression ϰατ’ ὄναρ is rejected by Photius as a barbarism but that it is attested from the time of Conon. But Matthew uses it several times for divine revelations (2:12, 13, 19, 22; 27:19).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft43",
      "id": "fn43"
    }
  }, [_vm._v("43")]), _vm._v(". So Turner, M, III, p. 77; he also says that the words mean “Never at any time in the future be afraid to take her to wife” ("), _c('em', [_vm._v("Grammatical Insights,")]), _vm._v(" p. 25). Matthew uses μή with the aorist imperative 29 times (he has it with the present imperative 12 times). Except for this passage and 3:9 all are in sayings of Jesus (M, I, pp. 123-24).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft44",
      "id": "fn44"
    }
  }, [_vm._v("44")]), _vm._v(". Matthew uses γάρ 124 times, which is more than any of the other Evangelists (Mark has it 64 times, Luke 97, and John 64). Turner points out that Matthew’s use of γάρ “is about the same as in Mark (one in 15 lines), less frequent than Paul and Hebrews, more so than Luke-Acts and the Johannine writings” (M, IV, p. 38). Matthew likes to bring out logical connections.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft45",
      "id": "fn45"
    }
  }, [_vm._v("45")]), _vm._v(". τίϰτω is the usual verb for the action of the female parent. Matthew has it 4 times.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v(". In his essay “Quis et Unde,” K. Stendahl says, “The genuine point is that the angel encourages Joseph, the son of David, to make this child a Davidic child. Thereby Jesus’ place in the genealogy is explained. God has ordered this engrafting” (Stanton, p. 61).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft47",
      "id": "fn47"
    }
  }, [_vm._v("47")]), _vm._v(". For the wordplay here see Introduction, p. 17, n. 58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft48",
      "id": "fn48"
    }
  }, [_vm._v("48")]), _vm._v(". λαός.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft49",
      "id": "fn49"
    }
  }, [_vm._v("49")]), _vm._v(". ἁμαρτία meant first a missing of the mark, and Trench notes that Aristotle “sometimes withdraws it, almost, if not altogether, from the region of right and wrong. … The ἁμαρτία is a mistake …” ("), _c('em', [_vm._v("Synonyms,")]), _vm._v(" p. 241). G. Stählin points out that in LXX sin is considered much more serious, and the word comes “to express the divine reference of sin much more purely than, e.g., such primarily ethical concepts as ἀδιϰία and ϰαϰία.” The New Testament follows LXX, and there “It is almost always a matter of ‘offence in relation to God with emphasis on guilt,’ i.e., of ‘sin’” ("), _c('em', [_vm._v("TDNT,")]), _vm._v(" I, p. 295).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft50",
      "id": "fn50"
    }
  }, [_vm._v("50")]), _vm._v(". ὅλος occurs in Matthew more often than in any other New Testament writing (22 times). It means “whole, entire, complete” (BAGD) and is not often found as it is here with a pronoun.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft51",
      "id": "fn51"
    }
  }, [_vm._v("51")]), _vm._v(". ἵνα usually denotes purpose. It is possible to see something like result because purpose and result are so closely connected when it is a matter of the divine will. But the conjunction normally indicates purpose, and there is no real reason for departing from that meaning here. Cf. Burton, “The writer of the first gospel never uses ἵνα to express result, either actual or conceived; and that he by this phrase at least intends to express purpose is made especially clear by his employment of ὅπως (which is never ecbatic) interchangeably with ἵνα” (MT, 222).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft52",
      "id": "fn52"
    }
  }, [_vm._v("52")]), _vm._v(". It is sometimes suggested that Matthew has manufactured a narrative to fit a number of prophecies, but M. J. Down has argued convincingly that “the evangelist did not start with prophecy and invent a story; he started with a story and slipped in certain prophecies” ("), _c('em', [_vm._v("ET,")]), _vm._v(" XC [1978-79], p. 52).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft53",
      "id": "fn53"
    }
  }, [_vm._v("53")]), _vm._v(". Isaiah uses the word "), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("צַלְמָה")]), _vm._v(", which is usually understood to mean a woman of marriageable age. The word occurs 7 times and is apparently not used for women who are married (though Prov. 30:19 may be an exception). France points out that the word is not elsewhere used where childbirth is in mind (and where “wife” would be expected) and that it may have been this indication that Isaiah had in mind a birth that did not conform to the usual pattern that caused the LXX translators to use παρθένος. This word in biblical Greek normally means “virgin” (though not in Gen. 34:3); it means “virgin” in Isaiah and here. Isaiah is speaking of happenings in the time of Ahaz, but Matthew perceives a fuller meaning. “Clearly the LXX translators, with their striking use of "), _c('em', [_vm._v("parthenos,")]), _vm._v(" understood it to refer to more than an ordinary birth, and the choice of "), _c('span', {
    staticClass: "splchar"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("almâ")]), _vm._v(" in the Hebrew as well as the symbolic name ‘Immanuel’ suggests that they were right” (France).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft54",
      "id": "fn54"
    }
  }, [_vm._v("54")]), _vm._v(". "), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("עִמָּבוּאֵל")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft55",
      "id": "fn55"
    }
  }, [_vm._v("55")]), _vm._v(". The Hebrew text of Isaiah reads, “she will call his name Emmanuel,” in LXX it is a command, “you (singular) shall call …,” while Matthew has “they will call. …” Matthew’s impersonal plural signifies people in general. Bruner comments, “There is some point in Matthew’s plural rendering because we never hear Jesus called Emmanu-El by his mother or by any particular person in the Gospels or Epistles. But if one were to ask the faithful through the centuries what they believe Jesus "), _c('em', [_vm._v("means")]), _vm._v(" to them, and thus in this sense what they "), _c('em', [_vm._v("call")]), _vm._v(" him, ‘God with us’ is as good an answer as it is possible to give in three words” (pp. 34-35).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft56",
      "id": "fn56"
    }
  }, [_vm._v("56")]), _vm._v(". The verb γινώσϰω means “come to know, know,” and is used of knowing in a wide variety of contexts. BAGD says that here it is “euphem. of sex relations”; it cites classical and late authors as well as LXX for this usage. The subject may be a man, as here, or a woman (Luke 1:34).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft57",
      "id": "fn57"
    }
  }, [_vm._v("57")]), _vm._v(". ἕως occurs 48 times in this Gospel, which is more than in any other New Testament book (next is Luke with 28). It may be used as a temporal conjunction or, as here, as an improper preposition with the genitive οὖ. BAGD sees the relative as used with prepositions “whereby a kind of conjunction is formed” (ὅς, ἥ, ὅ, for this passage I.11.f). McNeile says that in the New Testament a negative followed by ἕως οὗ ἕως, or ἕως ὅτον “always implies that the negatived action did, or will, take place after the point of time indicated by the particle.” Matthew uses ἕως οὗ 5 times.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d636f40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Chapter01.vue
// module id = 78
// module chunks = 0